<template>
  <b-container>
    <b-table
      striped
      hover
      id="my-table"
      :fields="fields"
      :items="itemsArg"
      :per-page="perPage"
      :current-page="currentPage"
    >
      <template v-slot:cell(show_details)="row">
        <b-button size="sm" @click="row.toggleDetails" class="mr-2">
          {{ row.detailsShowing ? "-" : "+" }}
        </b-button>
      </template>
      <template v-slot:row-details="row">
        <b-table :fields="subFields" :items="row.item.Files" id="sub-table">
          <template v-slot:cell(Files)="data">
            <a target="_blank" :href="data.item.ChangeURL"> {{ data.item.ChangeItem }} </a>
          </template>
        </b-table>
      </template>
    </b-table>
    <b-pagination
      v-model="currentPage"
      :per-page="perPage"
      aria-controls="my-table"
      :total-rows="rows"
      pills
      size="sm"
    >
    </b-pagination>
  </b-container>
</template>

<script>
export default {
  name: "FileList",
  props: ["itemsArg"],
  data: function() {
    return {
      perPage: 15,
      currentPage: 1,
      fields: [
        { key: "Name", sortable: true },
        { key: "Road Type", sortable: true },
        { key: "County", sortable: true },
        { key: "show_details" },
      ],
      subFields: ["Files"],
    };
  },
  computed: {
    rows() {
      return this.itemsArg.length;
    },
  },
};
</script>
